export const CARE_WASHING_OPTIONS = [
  'not_allowed_machine',
  'machine_30',
  'machine_40',
  'machine_60',
  'machine_90'
];

export const CARE_BLEACHING_OPTIONS = [
  'bleach_allowed',
  'bleach_not_allowed'
];

export const CARE_DRYING_OPTIONS = [
  'tumble_not_allowed',
  'tumble_high_max',
  'tumble_low_regular',
  'tumble_medium_regular',
  'tumble_high_regular'
];

export const CARE_IRONING_OPTIONS = [
  'iron_not_allowed',
  'iron_low_110',
  'iron_medium_150',
  'iron_high_200'
];

export const CARE_DRY_CLEANING_OPTIONS = [
  'dry_clean_not_allowed',
  'dry_clean_any_except_trichloroethylene'
];

/** Default care labels when creating a new dress (Serbian standard labels in UI via i18n). */
export const DEFAULT_DRESS_CARE = {
  care_washing: 'machine_30',
  care_bleaching: 'bleach_not_allowed',
  care_drying: 'tumble_not_allowed',
  care_ironing: 'iron_low_110',
  care_dry_cleaning: 'dry_clean_any_except_trichloroethylene'
};

const CARE_FIELD_TO_I18N = {
  care_washing: 'careWashing',
  care_bleaching: 'careBleaching',
  care_drying: 'careDrying',
  care_ironing: 'careIroning',
  care_dry_cleaning: 'careDryCleaning'
};

/** English defaults for t(key, defaultValue, params) */
export const CARE_OPTION_DEFAULTS = {
  careWashing: {
    not_allowed_machine: 'Machine washing not allowed.',
    machine_30: 'Machine wash up to 30°C.',
    machine_40: 'Machine wash up to 40°C.',
    machine_60: 'Machine wash up to 60°C.',
    machine_90: 'Machine wash up to 90°C.'
  },
  careBleaching: {
    bleach_allowed: 'Bleach may be used.',
    bleach_not_allowed: 'Do not use any bleach.'
  },
  careDrying: {
    tumble_not_allowed: 'Do not tumble dry.',
    tumble_high_max: 'Tumble dry on highest heat setting.',
    tumble_low_regular: 'Tumble dry regularly on low heat.',
    tumble_medium_regular: 'Tumble dry regularly on medium heat.',
    tumble_high_regular: 'Tumble dry regularly on high heat.'
  },
  careIroning: {
    iron_not_allowed: 'Do not iron or press.',
    iron_low_110: 'Iron at low temperature up to 110°C; steam not recommended.',
    iron_medium_150: 'Iron at medium temperature up to 150°C; with or without steam.',
    iron_high_200: 'Iron at high temperature up to 200°C; with or without steam.'
  },
  careDryCleaning: {
    dry_clean_not_allowed: 'Do not dry clean.',
    dry_clean_any_except_trichloroethylene: 'Any solvent except trichloroethylene may be used.'
  }
};

export function formatDressCareValue(t, fieldName, value) {
  if (!value) return '—';
  const i18nGroup = CARE_FIELD_TO_I18N[fieldName];
  if (!i18nGroup) return value;
  const defaults = CARE_OPTION_DEFAULTS[i18nGroup] || {};
  const defaultLabel = defaults[value] || value;
  return t(`dresses.${i18nGroup}.${value}`, defaultLabel, {});
}

export function getCareSelectOptions(fieldName, optionKeys, t) {
  const i18nGroup = CARE_FIELD_TO_I18N[fieldName];
  const defaults = CARE_OPTION_DEFAULTS[i18nGroup] || {};
  return optionKeys.map((key) => ({
    value: key,
    label: t(`dresses.${i18nGroup}.${key}`, defaults[key] || key, {})
  }));
}
